exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".result-title{padding:10px;text-align:center;font-size:22px}.result-created{padding:10px;text-transform:uppercase;color:#36a8da;margin-bottom:-15px}.result-created-date{color:#199cd5;font-weight:700}.step-header{margin-top:25px;background-color:#cceef6;padding:15px;font-size:21px}.step-container{padding:0}.step-item{padding:15px}.step-item:nth-child(2n){background-color:#f0f0f0}.button-section{display:flex;justify-content:flex-start;flex-wrap:wrap}.step-btn{width:250px;margin:10px 0 20px 20px;text-align:center;padding:12px 0;background-color:#337ab7;font-size:16px;text-transform:uppercase;cursor:pointer;color:#fff}.step-btn:hover{background-color:#0d3a73}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-44751f24","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ResultScreen.vue
// module id = 30
// module chunks = 0